import { render, staticRenderFns } from "./ParagraphWide.vue?vue&type=template&id=616f1958&scoped=true"
import script from "./ParagraphWide.vue?vue&type=script&lang=js"
export * from "./ParagraphWide.vue?vue&type=script&lang=js"
import style0 from "./ParagraphWide.vue?vue&type=style&index=0&id=616f1958&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "616f1958",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/Frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('616f1958')) {
      api.createRecord('616f1958', component.options)
    } else {
      api.reload('616f1958', component.options)
    }
    module.hot.accept("./ParagraphWide.vue?vue&type=template&id=616f1958&scoped=true", function () {
      api.rerender('616f1958', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/atoms/ParagraphWide.vue"
export default component.exports